import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports

function UpdateProperty() {
    this.defaultAttrs({
        dataKey: null,
        eventName: null,
        property: null,
    });

    this.after('initialize', function() {
        this.on(document, this.attr.eventName, this.updateProperty);
    });

    this.updateProperty = function(e, data) {
        if (data[this.attr.dataKey]) {
            this.$node.prop(this.attr.property, data[this.attr.dataKey]);
        }
    };
}

export default defineComponent(UpdateProperty);



// WEBPACK FOOTER //
// ./src/js/component_ui/update-property.js